import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-create-page',
  templateUrl: './create-page.component.html',
  styleUrls: ['./create-page.component.scss']
})
export class CreatePageComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public placementsnewsForm: FormGroup;
  public placementsnews = [];

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/placementsnewsbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.placementsnewsForm.patchValue({
              _id: data.data._id,
              heading: data.data.heading,
              title: data.data.title,
              date: data.data.date,
              image: data.data.image,
              imagealt: data.data.imagealt,
              description: data.data.description,
              priority: data.data.priority,
              seohidden: data.data.seohidden
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.placementsnewsForm = this.formBuilder.group({
      heading: ['', Validators.required],
      title: [''],
      date: ['', Validators.required],
      image: ['', Validators.required],
      imagealt: ['', Validators.required],
      description: ['', Validators.required],
      priority: [''],
      _id: [''],
      seohidden: ['']
    })
  }

  get f() { return this.placementsnewsForm.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.placementsnewsForm.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    
    var data = {
      "heading" : this.placementsnewsForm.value.heading,
      "title" : this.placementsnewsForm.value.title,
      "date" : this.placementsnewsForm.value.date,
      "image" : this.placementsnewsForm.value.image,
      "imagealt" : this.placementsnewsForm.value.imagealt,
      "description" : this.placementsnewsForm.value.description,
      "priority" : this.placementsnewsForm.value.priority,
      "content_url" : this.placementsnewsForm.value.heading.toLowerCase().replace(/ /g, '-'),
      "admin" : sessionStorage.getItem('adminName'),
      "seohidden": this.placementsnewsForm.value.seohidden
    };
    // console.log(data);
    this.http.post<any>(this.api_endpoint+'/placementsnews', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/placementsnews/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }else{
    var data1 = {
      "heading" : this.placementsnewsForm.value.heading,
      "title" : this.placementsnewsForm.value.title,
      "date" : this.placementsnewsForm.value.date,
      "image" : this.placementsnewsForm.value.image,
      "imagealt" : this.placementsnewsForm.value.imagealt,
      "description" : this.placementsnewsForm.value.description,
      "priority" : this.placementsnewsForm.value.priority,
      "content_url" : this.placementsnewsForm.value.heading.toLowerCase().replace(/ /g, '-'),
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.placementsnewsForm.value._id,
      "seohidden": this.placementsnewsForm.value.seohidden
    };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/placementsnews/', data1).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/placementsnews/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }


}
